import { Box, Button, Link, Stack, Text } from "@chakra-ui/react";
import React from "react";

const BookAMeetingBlogSection = () => {
  return (
    <Box
      my={12}
      borderRadius="12px"
      w="100%"
      h="255px"
      bg="linear-gradient(120deg, #B85078 10.49%, #522C85 54.93%, #3F2167 98.24%)"
    >
      <Stack h="100%" alignItems="center" justifyContent="center" mx="auto">
        <Text
          zIndex="1000"
          fontWeight="700"
          color="#fff !important"
          fontSize="30px"
          lineHeight="36px"
          px={40}
          textAlign="center"
        >
          Do you need custom solutions or information?
        </Text>
        <Text color="#fff !important" fontSize="18px" lineHeight="27px">
          Our team is eager to assist you.
        </Text>
        <Link
          href="https://medsupplysolutions.youcanbook.me/"
          target="_blank"
          rel="noopener"
        >
          <Button
            bgColor="#3B2060"
            h="48px"
            mt="12px"
            color="#0E0418"
            bg="#fff"
            fontWeight="600"
            borderRadius="6px"
            fontSize="18px"
            _hover={{ bg: "#6A3AAB", color: "#fff" }}
            w="195px"
          >
            Book a Meeting
          </Button>
        </Link>
      </Stack>
    </Box>
  );
};

export default BookAMeetingBlogSection;
